import mapActions from './mapActions';

export default mapActions('certifications', {
    fetchAll_url: data => `/api/certifications/employees/${data.id}`
});
